export default "__VITE_ASSET__kgC8a6Wd__"